<script>
import { mapState } from 'vuex'
import date from 'locutus/php/datetime/date'
import strtotime from 'locutus/php/datetime/strtotime'
import PageNavigation from '@components/admin/page-navigation'
import { fetchShareList, fetchRelationList } from '@apis/brokerage'
import pickBy from 'lodash/pickBy'
import pick from 'lodash/pick'
import fromPairs from 'lodash/fromPairs'
import map from 'lodash/map'
import mapKeys from 'lodash/mapKeys'
import Decimal from 'decimal.js'

export default {
  components: { PageNavigation },
  data() {
    return {
      loading: false,
      list: [],
      total_count: 0,
      page: 1,
      relations: [],
      total_page: 0,
      page_navigation: {},
      search_params: {},
      count_groups: null,
      view_mode: 'TABLE',
      excel_headers: [
        ['seq', this.$t('share_list.seq')],
        ['amount', this.$t('share_list.amount')],
        ['asset_code', this.$t('share_list.asset_code')],
        ['asset_seq', this.$t('share_list.asset_seq')],
        ['asset_title', this.$t('share_list.asset_title')],
        ['base_amount', this.$t('share_list.base_amount')],
        ['base_amount_target', this.$t('share_list.base_amount_target')],
        [
          'benefactor_email_address',
          this.$t('share_list.benefactor_email_address'),
        ],
        ['benefactor_member_seq', this.$t('share_list.benefactor_member_seq')],
        ['benefactor_type', this.$t('share_list.benefactor_type')],
        ['benefactor_user_id', this.$t('share_list.benefactor_user_id')],
        ['benefactor_user_name', this.$t('share_list.benefactor_user_name')],
        [
          'beneficiary_email_address',
          this.$t('share_list.beneficiary_email_address'),
        ],
        [
          'beneficiary_member_seq',
          this.$t('share_list.beneficiary_member_seq'),
        ],
        ['beneficiary_type', this.$t('share_list.beneficiary_type')],
        ['beneficiary_user_id', this.$t('share_list.beneficiary_user_id')],
        ['beneficiary_user_name', this.$t('share_list.beneficiary_user_name')],
        ['causer_email_address', this.$t('share_list.causer_email_address')],
        ['causer_seq', this.$t('share_list.causer_seq')],
        ['causer_user_id', this.$t('share_list.causer_user_id')],
        ['causer_user_name', this.$t('share_list.causer_user_name')],
        ['log_beneficiary_seq', this.$t('share_list.log_beneficiary_seq')],
        ['log_policy_seq', this.$t('share_list.log_policy_seq')],
        ['log_seq', this.$t('share_list.log_seq')],
        ['policy_amount', this.$t('share_list.policy_amount')],
        ['policy_seq', this.$t('share_list.policy_seq')],
        ['policy_title', this.$t('share_list.policy_title')],
        ['target_action', this.$t('share_list.target_action')],
        ['target_seq', this.$t('share_list.target_seq')],
        [
          'affiliate_log_benefactor_seq',
          this.$t('share_list.affiliate_log_benefactor_seq'),
        ],
        ['brokerage_seq', this.$t('share_list.brokerage_seq')],
        ['brokerage_title', this.$t('share_list.brokerage_title')],
        ['inherited_amount', this.$t('share_list.inherited_amount')],
        ['acquire_rate', this.$t('share_list.acquire_rate')],
        [
          'acquire_rate_from_amount',
          this.$t('share_list.acquire_rate_from_amount'),
        ],
        ['acquire_amount', this.$t('share_list.acquire_amount')],
        ['regdate', this.$t('share_list.regdate')],
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('share_list.shortcuts_today'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('today') * 1000),
                new Date(strtotime('tomorrow') * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('share_list.shortcuts_yesterday'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('yesterday') * 1000),
                new Date(strtotime('today') * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('share_list.shortcuts_thismonth'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(
                  strtotime('today', strtotime('first day of this month')) *
                    1000
                ),
                new Date(
                  strtotime('today', strtotime('first day of next month')) *
                    1000 -
                    1
                ),
              ])
            },
          },
          {
            text: this.$t('share_list.shortcuts_today'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(
                  strtotime('today', strtotime('first day of last month')) *
                    1000
                ),
                new Date(
                  strtotime('today', strtotime('first day of this month')) *
                    1000 -
                    1
                ),
              ])
            },
          },
          {
            text: this.$t('share_list.shortcuts_thisweek'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('today', strtotime('this week')) * 1000),
                new Date(strtotime('today', strtotime('next week')) * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('share_list.shortcuts_lastweek'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('today', strtotime('last week')) * 1000),
                new Date(strtotime('today', strtotime('this week')) * 1000 - 1),
              ])
            },
          },
          {
            text: this.$t('share_list.shortcuts_week'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('-7 day') * 1000),
                new Date(),
              ])
            },
          },
          {
            text: this.$t('share_list.shortcuts_month'),
            onClick(picker) {
              picker.$emit('pick', [
                new Date(strtotime('-30 day') * 1000),
                new Date(),
              ])
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState('common', {
      constants: (state) => state.constants,
    }),
    c_regdate_range: {
      get() {
        const regdate_start = this.search_params.regdate_start || ''
        const regdate_end = this.search_params.regdate_end || ''
        return [
          regdate_start ? new Date(regdate_start * 1) : '',
          regdate_end ? new Date(regdate_end * 1) : '',
        ]
      },
      set([start, end]) {
        this.$set(
          this.search_params,
          'regdate_start',
          start ? `${start.getTime()}` : undefined
        )
        this.$set(
          this.search_params,
          'regdate_end',
          end ? `${end.getTime()}` : undefined
        )
      },
    },
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.query.page || 1
      this.loadList().catch((e) => this.$toasted.error(e.message))
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.page = this.$route.query.page || 1
      this.search_params = { ...this.$route.query }
      Promise.all([this.loadList(), this.loadRelations()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadList() {
      this.loading = true
      const ret_obj = await fetchShareList({
        ...this.$route.params,
        ...pickBy(this.$route.query, (v) => v !== undefined),
      })

      this.count_groups = this.countByGroup(ret_obj.data, [
        'log_seq',
        'log_policy_seq',
        'log_benefactor_seq',
      ])
      this.list = ret_obj.data.map((val) => ({
        ...val,
        acquire_rate_from_amount: new Decimal(val.amount).eq(0)
          ? '0'
          : new Decimal(val.acquire_amount)
              .div(val.amount)
              .mul(100)
              .toString(),
      }))
      this.total_count = ret_obj.total_count
      this.total_page = ret_obj.total_page
      this.page_navigation = ret_obj.page_navigation
    },
    async loadRelations() {
      const { data } = await fetchRelationList({
        ...this.$route.params,
        no_paging: 1,
      })

      this.relations = data
    },
    search() {
      this.$router.push({ query: this.search_params })
    },
    handleShowLogVars(log_seq) {
      this.s_log_seq = log_seq
      this.show_log_vars = true
    },
    countByGroup(items, fields) {
      const count_groups = fromPairs(
        map(fields, (val) => [val, { counts: {}, first_indexes: [] }])
      )
      const cur_value = fromPairs(map(fields, (val) => [val, null]))

      items.forEach((item, idx) => {
        fields.forEach((field) => {
          if (cur_value[field] !== item[field]) {
            count_groups[field].first_indexes.push(idx)
            cur_value[field] = item[field]
          }

          const counts = count_groups[field].counts

          counts[item[field]] = counts[item[field]] || 0
          counts[item[field]]++
        })
      })

      return count_groups
    },
    date,
    fromPairs,
    async handleExportExcel() {
      this.loading = true
      try {
        if (
          !(await this.$confirm(
            this.$t('share_list.msg_server_overload'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        const { data } = await fetchShareList({
          ...this.$route.params,
          ...pickBy(this.$route.query, (v) => v !== undefined),
          no_paging: 1,
        })

        const { default: exportJsonToExcel } = await import(
          '@utils/export-json-to-excel'
        )
        exportJsonToExcel({
          header: map(this.excel_headers, ([, title]) => title),
          data: this.format2excel(data),
          filename: this.$t('share_list.equity_history', [date('YmdHis')]),
        })
      } catch (e) {
        this.$toasted.error(e.message)
      } finally {
        this.loading = false
      }
    },
    format2excel(list) {
      const excel_fields = map(this.excel_headers, ([name]) => name)
      return map(list, (data) => {
        let result = pick(data, excel_fields)
        const keys = Object.keys(result)
        result = mapKeys(
          map(result, (val, key) => {
            switch (key) {
              case 'target_action':
                return fromPairs(this.constants.affiliate.policy.target_action)[
                  val
                ]
              case 'benefactor_type':
              case 'base_amount_target':
                return fromPairs(
                  this.constants.affiliate.policy_benefactor[key][
                    result.target_action
                  ]
                )[val]
              case 'beneficiary_type':
                return fromPairs(
                  this.constants.affiliate.policy_beneficiary.beneficiary_type[
                    result.target_action
                  ]
                )[val]
              case 'regdate':
                return val ? date('Y-m-d H:i:s', new Date(val)) : ''
              default:
                return val
            }
          }),
          (val, key) => {
            return keys[key]
          }
        )

        return map(excel_fields, (key) => result[key])
      })
    },
  },
}
</script>

<template>
  <div v-loading="loading">
    <h3 :class="$style.xeAdmin">{{ $t('share_list.search') }}</h3>
    <form @submit.prevent="search">
      <table cellspacing="0" cellpadding="0" :class="$style.rowTable">
        <colgroup>
          <col width="20%" />
          <col width="30%" />
          <col width="20%" />
          <col width="30%" />
        </colgroup>
        <tbody>
          <tr>
            <td colspan="4">
              <el-date-picker
                v-model="c_regdate_range"
                :class="$style.fr"
                type="datetimerange"
                :picker-options="pickerOptions"
                :clearable="false"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                align="right"
              >
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <th scope="col">
              <div>
                <select
                  v-model="search_params.search_target"
                  :class="$style.fullWidth"
                >
                  <option
                    v-for="val in [
                      [undefined, $t('admin.search_target')],
                      ['user_id', $t('admin.user_id')],
                      ['email_address', $t('admin.email_address')],
                      ['user_name', $t('admin.user_name')],
                      ['ipaddress', $t('admin.ipaddress')],
                      ['user_agent', $t('admin.user_agent')],
                      ['regdate_more', $t('admin.login_log_regdate_more')],
                      ['regdate_less', $t('admin.login_log_regdate_less')],
                    ]"
                    :key="val[1]"
                    :value="val[0]"
                    >{{ val[1] }}</option
                  >
                </select>
              </div>
            </th>
            <td>
              <input
                v-model="search_params.search_keyword"
                :placeholder="$t('admin.search_word')"
                type="text"
                :class="[$style.inputTypeText, $style.fullWidth]"
              />
            </td>
            <th scope="col">
              <div>
                {{ $t('share_list.sub_broker') }}
              </div>
            </th>
            <td>
              <select v-model="search_params.brokerage_seq">
                <option :value="undefined">{{
                  $t('share_list.not_select')
                }}</option>
                <option
                  v-for="val in relations"
                  :key="val.seq"
                  :value="val.child_seq"
                  >{{ val.child_title }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.sort') }}</div></th
            >
            <td>
              <select v-model="search_params.sort_order">
                <option
                  v-for="val in [
                    [undefined, $t('admin.regdate')],
                    ['last_login', $t('admin.last_login')],
                  ]"
                  :key="val[1]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
              <select v-model="search_params.order_type">
                <option
                  v-for="val in [
                    [undefined, $t('admin.desc')],
                    ['asc', $t('admin.asc')],
                  ]"
                  :key="val[1]"
                  :value="val[0]"
                  >{{ val[1] }}</option
                >
              </select>
            </td>
          </tr>
          <tr>
            <th colspan="4" :class="$style.button">
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="
                  search_params = {}
                  search
                "
                ><span>{{ $t('admin.reset') }}</span></a
              >
              {{ ' ' }}
              <span :class="[$style.button, $style.black]"
                ><input type="submit" :value="$t('admin.submit')"
              /></span>
            </th>
          </tr>
        </tbody>
      </table>
    </form>
    <h3 :class="$style.xeAdmin">{{ $t('share_list.equity_history') }}</h3>
    <fieldset :class="$style.clearfix">
      <div :class="$style.fl">
        <a href="#" :class="[$style.button]" @click.prevent="handleExportExcel"
          ><span>{{ $t('admin.excel_download') }}</span></a
        >
      </div>
    </fieldset>
    <table
      v-if="view_mode === 'TABLE'"
      cellspacing="0"
      cellpadding="0"
      :class="$style.crossTable"
    >
      <caption v-if="!loading"
        >Total {{ total_count }}, Page {{ page }}/{{ total_page }}</caption
      >
      <thead>
        <tr>
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('share_list.causer') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('share_list.behavior_type') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('share_list.target_seq') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('share_list.occurrence_date') }}</div></th
          >
          <th scope="col" rowspan="2" :class="$style.quarter_wide"
            ><div>{{ $t('share_list.applied_policy_name') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide" rowspan="2"
            ><div>{{ $t('share_list.benefactor_type') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide" rowspan="2"
            ><div>{{ $t('share_list.beneficiary') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide" rowspan="2"
            ><div>{{ $t('share_list.base_amount_target') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide" rowspan="2"
            ><div>{{ $t('share_list.base_amount') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide" rowspan="2"
            ><div>{{ $t('share_list.allowance_assets') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide" rowspan="2"
            ><div>{{ $t('share_list.allowance_amount') }}</div></th
          >
          <th scope="col" rowspan="2"
            ><div
              ><a href="#">{{ $t('share_list.number') }}</a></div
            ></th
          >
          <th scope="col" :class="$style.quarter_wide" colspan="2"
            ><div>{{ $t('share_list.brokerage_name') }}</div></th
          >
        </tr>
        <tr>
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('share_list.acquisition_rate') }}</div></th
          >
          <th scope="col" :class="$style.quarter_wide"
            ><div>{{ $t('share_list.acquisition_amount') }}</div></th
          >
        </tr>
      </thead>
      <tbody>
        <template v-for="(data, idx) in list">
          <tr :key="`${data.seq}-1`">
            <template
              v-if="count_groups.log_seq.first_indexes.indexOf(idx) !== -1"
            >
              <td
                :class="[$style.center, $style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{ data.causer_user_id }}</td
              >
              <td
                :class="[$style.center, $style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{
                  fromPairs(constants.affiliate.policy.target_action)[
                    data.target_action
                  ]
                }}</td
              >
              <td
                :class="[$style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{ data.target_seq }}</td
              >
              <td
                :class="[$style.center, $style.nowrap]"
                :rowspan="count_groups.log_seq.counts[data.log_seq] * 2"
                >{{ date('Y-m-d H:i:s', new Date(data.regdate)) }}</td
              >
            </template>
            <template
              v-if="
                count_groups.log_policy_seq.first_indexes.indexOf(idx) !== -1
              "
            >
              <td
                :class="[$style.wide]"
                :rowspan="
                  count_groups.log_policy_seq.counts[data.log_policy_seq] * 2
                "
                >{{ data.policy_title }}</td
              >
            </template>
            <template
              v-if="
                count_groups.log_benefactor_seq.first_indexes.indexOf(idx) !==
                  -1
              "
            >
              <td
                :colspan="data.benefactor_member_seq === -1 ? 2 : false"
                :rowspan="
                  count_groups.log_benefactor_seq.counts[
                    data.log_benefactor_seq
                  ] * 2
                "
                :class="[$style.center, $style.tCenter, $style.nowrap]"
                >{{
                  fromPairs(
                    constants.affiliate.policy_benefactor.benefactor_type[
                      data.target_action
                    ]
                  )[data.benefactor_type]
                }}</td
              >
              <td
                v-if="data.benefactor_member_seq !== -1"
                :rowspan="
                  count_groups.log_benefactor_seq.counts[
                    data.log_benefactor_seq
                  ] * 2
                "
                :class="[$style.center, $style.tCenter, $style.nowrap]"
                >{{ data.benefactor_user_id }}</td
              >
              <td
                :rowspan="
                  count_groups.log_benefactor_seq.counts[
                    data.log_benefactor_seq
                  ] * 2
                "
                :class="[$style.center, $style.tCenter, $style.nowrap]"
                >{{
                  fromPairs(
                    constants.affiliate.policy_benefactor.base_amount_target[
                      data.target_action
                    ]
                  )[data.base_amount_target]
                }}</td
              >
              <td
                :rowspan="
                  count_groups.log_benefactor_seq.counts[
                    data.log_benefactor_seq
                  ] * 2
                "
                :class="[$style.tRight, $style.nowrap]"
                >{{ data.base_amount | trimDecimalZero | numberFormat }}</td
              >
              <td
                :rowspan="
                  count_groups.log_benefactor_seq.counts[
                    data.log_benefactor_seq
                  ] * 2
                "
                :class="[$style.tCenter, $style.nowrap]"
                >{{ data.asset_title }}</td
              >
              <td
                :rowspan="
                  count_groups.log_benefactor_seq.counts[
                    data.log_benefactor_seq
                  ] * 2
                "
                :class="[$style.tRight, $style.nowrap]"
              >
                {{ data.amount | trimDecimalZero | numberFormat }}
                <template v-if="data.base_amount_target !== '__FIXED__'">
                  ({{ data.policy_amount | trimDecimalZero | numberFormat }}%)
                </template>
              </td>
            </template>
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.center,
                $style.tCenter,
                $style.nowrap,
              ]"
              rowspan="2"
              >{{ `${data._no}` | numberFormat }}</td
            >
            <td :colspan="2" :class="[{ [$style.row2]: data._no % 2 }]">{{
              data.brokerage_title
            }}</td>
          </tr>
          <tr :key="`${data.seq}-2`">
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.tRight,
                $style.nowrap,
              ]"
              >{{
                data.acquire_rate_from_amount | trimDecimalZero | numberFormat
              }}
              %</td
            >
            <td
              :class="[
                { [$style.row2]: data._no % 2 },
                $style.tRight,
                $style.nowrap,
              ]"
              >{{ data.acquire_amount | trimDecimalZero | numberFormat }}</td
            >
          </tr>
        </template>
        <tr v-if="loading">
          <td :colspan="15" :class="[$style.tCenter, $style.center]">{{
            $t('admin.loading')
          }}</td>
        </tr>
        <tr v-else-if="!list.length">
          <td :colspan="15" :class="[$style.tCenter, $style.center]">{{
            $t('share_list.msg_brokerage_catalog_share_list_no')
          }}</td>
        </tr>
      </tbody>
    </table>
    <PageNavigation
      v-if="!loading"
      :total_count="total_count"
      :total_page="page_navigation.total_page"
      :cur_page="page"
      :page_count="page_navigation.page_count"
    ></PageNavigation>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

.crossTable th,
.crossTable td {
  vertical-align: middle;
}
.adminTable,
.crossTable {
  // display: block;
  overflow: auto;
  ruby > rt {
    text-align: center;
  }
  ruby {
    font-weight: bold;
    color: #0068c1;
  }
  .row2 {
    background-color: #f3f3f3;
  }
}
</style>
